import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useState,useEffect } from "react";
import editapi from '../api/viewstudenthistoryRouter';
import sadminapi from '../api/sadminapi';
import loginapi from '../api/login';
import { AiOutlineDownload } from "react-icons/ai";
import { APISERVERURL } from '../APIServerURL';
const gradeOptions = ["","O", "A+", "A", "B+", "B", "C+", "C", "P", "F", "W", "AB","ABS"];

const CourseGradeTable = ({ courseMap, sessions}) => {
  const [courses, setCourses] = useState(courseMap);
  return (
    <div className="overflow-x-auto">

       {(<table className="min-w-full border border-gray-300 rounded-lg mt-4 text-sm">
        <thead className="bg-gray-100">
          <tr>            
        
             <th className="px-4 py-2 border">Session</th>
            <th className="px-4 py-2 border">Semester</th>
            <th className="px-4 py-2 border">Course Code</th>
             <th className="px-4 py-2 border">Credit</th>
            <th className="px-4 py-2 border">Type</th>

            <th className="px-4 py-2 border">MT</th>
            <th className="px-4 py-2 border">PR</th>
            <th className="px-4 py-2 border">ET</th>

            <th className="px-4 py-2 border">MD/30</th>
            <th className="px-4 py-2 border">END/70</th>

            <th className="px-4 py-2 border">/100</th>

            <th className="px-4 py-2 border">Grade</th>
          </tr>
        </thead>
        <tbody>
          {courses.map((course, index) => (
           <tr
                key={course.course_code + index}
                className={`${
                  course.markDelete ? 'bg-red-200' : index % 2 === 0 ? 'bg-white' : 'bg-blue-100'
                }`}
              >
             
                <td className="px-4 py-2 border text-center">{course.session}</td>
              <td className="px-4 py-2 border text-center">{course.semester}</td>
             <td className="px-4 py-2 border">{course.course_code}</td>
             <td className="px-4 py-2 border">{course.credit}</td>
              <td className="px-4 py-2 border">{course.course_type}</td>

               <td className="px-4 py-2 border">{course.midterm_total}</td>
                <td className="px-4 py-2 border">{course.practical_total}</td>
                 <td className="px-4 py-2 border">{course.endterm_total}</td>

                  <td className="px-4 py-2 border">{course.midterm_30}</td>
                   <td className="px-4 py-2 border">{course.endterm_70}</td>

                    <td className="px-4 py-2 border">{course.midterm_30+course.endterm_70}</td>
              
              
              <td className="px-4 py-2 border">{course.grade}</td>
            </tr>
          ))}
        </tbody>
      </table>)} 

      
    </div>
  );
};




function RunningTranscript({accessToken,setAccessToken,setRefreshFailed,sessions  }) {
  const navigate = useNavigate();
  const [rollno,setRollno]=useState('');  
  const [session,setSession]=useState('');  
  const [error,setError]=useState('');
  const [result,setResult]=useState(null);
  const [user,setUser]=useState('');
  const [searching,setSearching]=useState(false);
    const [isDownloading,setIsDownloading]=useState(false);
        const [isDownloadingTx,setIsDownloadingTx]=useState(false);
           const [isDownloadingTxLegal,setIsDownloadingTxLegal]=useState(false);
  const handleGoBack = () => {
    navigate(`/`); 
  };

const sessionChanged = async (e) => {
    const session = e.target.value;
    setSession(session);

  };

const handleRollnoChange = (e) => {
    setRollno(e.target.value);
  
    setError('');
   
  };


    
    async function handleSearch()
        {
          setSearching(true);
           setResult(null);
          try{
            const response= await editapi.post('/getRunningTranscript',{ rollno},{headers:{'Authorization':`Bearer ${accessToken}`}});    
              setResult(response.data.result);
              setUser(response.data.userName);
          }
          catch(err)
          {
            if( err.response.status===403)
              {
                navigate(`/accessdenied`); 
              }
            try{
              const config = { withCredentials: true };
              const x=await loginapi.get('/getAccessToken',config);
              
              const nat=x['data']['accessToken'];
              setAccessToken(nat);
              try{       
                const response= await editapi.post('/getRunningTranscript',{ rollno},{headers:{'Authorization':`Bearer ${nat}`}});    
                       setResult(response.data.result);   
                        setUser(response.data.userName); 
               }
               catch(err)
               {
                if( err.response.status===403)
                  {
                    navigate(`/accessdenied`); 
                  }
                alert('unusual error newposts.js');
               }
            }
            catch(err)
            {
              alert('failed');
            }
    
          }
          finally{
            setSearching(false);
          }
        }
  
     

        function downloadFile(fname)
            {
              fetch(`${APISERVERURL}/pdf/${fname}`).then((response) => {
                response.blob().then((blob) => {
                 
                    // Creating new object of PDF file
                    const fileURL =
                        window.URL.createObjectURL(blob);
                         
                    // Setting various property values
                    let alink = document.createElement("a");
                    alink.href = fileURL;
                    alink.download = fname;
                    alink.click();
                    //setIsloading(false);
                });
              });
            }
          async function handleDownloadGradeCards(e,bg)
            {
              e.preventDefault();
              setIsDownloading(true);
              try{
                //session, batch, semester,bg
                const response= await editapi.post('/getAllGradeCardOfAStudent',{rollno,bg:'YES'},{headers:{'Authorization':`Bearer ${accessToken}`}});    
                alert(response.data);
                downloadFile(response.data);
              }
              catch(err)
              {
                try{
                  const config = { withCredentials: true };
                  const x=await loginapi.get('/getAccessToken',config);
                  
                  const nat=x['data']['accessToken'];
                  setAccessToken(nat);
                  try{       
                    const response= await editapi.post('/getAllGradeCardOfAStudent',{rollno,bg:'YES'},{headers:{'Authorization':`Bearer ${nat}`}});    
                    downloadFile(response.data);
                   }
                   catch(err)
                   {
                    alert('unusual error newposts.js');
                   }
                }
                catch(err)
                {
                  alert('failed');
                }
        
              }
              finally
              {
                setIsDownloading(false);
              }
            }

async function handleDownloadTranscript(e,bg="yes",type="A4")
            {
              e.preventDefault();
              if(type==="A4")
              {
                setIsDownloadingTx(true);
              }
              else{
                setIsDownloadingTxLegal(true);
              }
              
              try{
                //session, batch, semester,bg
                const response= await editapi.post('/printTranscriptOfAStudent',{rollno,bg:'YES',type:type},{headers:{'Authorization':`Bearer ${accessToken}`}});    
                alert(response.data);
                downloadFile(response.data);
              }
              catch(err)
              {
                try{
                  const config = { withCredentials: true };
                  const x=await loginapi.get('/getAccessToken',config);
                  
                  const nat=x['data']['accessToken'];
                  setAccessToken(nat);
                  try{       
                    const response= await editapi.post('/printTranscriptOfAStudent',{rollno,bg:'YES',type:type},{headers:{'Authorization':`Bearer ${nat}`}});    
                    downloadFile(response.data);
                   }
                   catch(err)
                   {
                    alert('unusual error newposts.js');
                   }
                }
                catch(err)
                {
                  alert('failed');
                }
        
              }
              finally
              {
                if(type==="A4")
              {
                setIsDownloadingTx(false);
              }
              else{
                setIsDownloadingTxLegal(false);
              }
              }
            }

            
  return (
     <main className="w-full">
         <div className="flex flex-col items-center w-full">


         <div className="w-full bg-red-100 relative py-1">
            {/* Absolute Positioned Button */}
            <button  onClick={handleGoBack}  className="absolute top-1.5 left-1.5 bg-red-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-red-600 transition duration-300 text-xs">
              BACK
            </button>

            {/* Heading */}
            <h1 className="text-2xl  text-gray-400 text-center"> STUDENT HISTORY</h1>
            <p className="w-full text-center font-semibold text-xs text-transparent">(The form is autosave)</p>    
          </div>

    

      <div className="flex flex-col justify-center gap-4 mt-4">
       
        
        

        <div className="w-full flex flex-col items-center justify-center mt-4 ">
                <div
                  className="flex flex-col items-center justify-center  w-full max-w-[600px]  p-1 text-sm mb-2 "
                >
                 <p className="text-center">Rollno</p>

                <input
                                type="text" 
                                name="txtRollno"
                                value={rollno}
                                onChange={handleRollnoChange}
                              className="w-full p-2 mt-1 bg-transparent border-b border-gray-400 focus:border-green-500 focus:border-b outline-none transition-all"
                              />
               </div>

               {false && (<div
                  className="flex flex-col items-center justify-center  w-full max-w-[600px] p-1 text-sm mb-2 "
                >
                <p className="text-center">Select Exam session</p>
            <select
        value={session}
        onChange={(e) => sessionChanged(e)}
        className="w-full p-2 mt-1 bg-transparent border-b border-gray-400 focus:border-green-500 focus:border-b outline-none transition-all"
      >
        <option value="">-- Choose a session --</option>
        {sessions.map((session, index) => (
          <option key={index} value={session}>
            {session}
          </option>
        ))}
      </select>
               </div>)}


              <button
  className={`bg-green-500 text-white width-[150px] font-semibold px-6 py-2 rounded-full shadow-md transition-all duration-300 hover:bg-green-600 hover:scale-105 active:scale-95 
    ${searching ? "opacity-70 cursor-not-allowed" : ""}`}
  onClick={handleSearch}
  disabled={searching}
>
  {searching ? (
    <span className="flex items-center gap-2">
      <svg
        className="animate-spin h-5 w-5 text-white"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v8H4z"
        ></path>
      </svg>
      searching...
    </span>
  ) : (
    "SEARCH"
  )}
</button>


{result?.result&&(
  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 mt-6">
    <div className="flex flex-col items-start p-4 border rounded-lg shadow-sm bg-white">
    <span className="text-gray-500 text-xs">Name</span>
    <p className="text-base font-medium text-gray-800">{result.result.studentDetails.name}</p>
  </div>


  <div className="flex flex-col items-start p-4 border rounded-lg shadow-sm bg-white">
    <span className="text-gray-500 text-xs">Total All Credit</span>
    <p className="text-base font-medium text-gray-800">{result.result.totalAllCredit}</p>
  </div>

  <div className="flex flex-col items-start p-4 border rounded-lg shadow-sm bg-white">
    <span className="text-gray-500 text-xs">Total Major Credit</span>
    <p className="text-base font-medium text-gray-800">{result.result.totalMajorCredit}</p>
  </div>

<div className="flex flex-col items-start p-4 border rounded-lg shadow-sm bg-white">
    <span className="text-gray-500 text-xs">Total Major Point</span>
    <p className="text-base font-medium text-gray-800">{result.result.totalMajorGp}</p>
  </div>
  <div className="flex flex-col items-start p-4 border rounded-lg shadow-sm bg-white">
    <span className="text-gray-500 text-xs">Total All Point</span>
    <p className="text-base font-medium text-gray-800">{result.result.totalAllGp}</p>
  </div>

  <div className="flex flex-col items-start p-4 border rounded-lg shadow-sm bg-white">
    <span className="text-gray-500 text-xs">Major CGPA</span>
    <p className="text-base font-medium text-gray-800">{result.result.majorCgpa}</p>
  </div>

  <div className="flex flex-col items-start p-4 border rounded-lg shadow-sm bg-white">
    <span className="text-gray-500 text-xs">All CGPA</span>
    <p className="text-base font-medium text-gray-800">{result.result.allCgpa}</p>
  </div>  

  <div className="flex flex-col items-start p-4 border rounded-lg shadow-sm bg-white">
    <span className="text-gray-500 text-xs">Total Credit Earned</span>
    <p className="text-base font-medium text-gray-800">{result.result.totalCreditEarned}</p>
  </div>
</div>
)}


               {result?.result?.courseMap && (
  <div className="p-4">
      <h2 className="text-lg font-bold mb-2 text-center">Course Grade Table</h2>
      <CourseGradeTable courseMap={result?.result?.courseMap} sessions={sessions}/>
    
    </div>
)}


        </div>

       


      </div>
      </div>
    </main>
  );
}

export default RunningTranscript;
